module.exports = __webpack_public_path__ + "static/media/memory_outro_rhino_spritesheet.43348e7b.png";